import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import MyWalletSidebar from "../MyWalletSidebar";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import "./ExamCoursesPlan..css";
import "./ExamCourseWalletLayout.css";
import HeaderProfileSection from "../HeaderProfileSection";
import ExamCoursesCard from "./ExamCoursesCard";
import ExamCourseHeader from "./ExamCourseHeader";
import { useExamsByMasterExam } from "../../hooks/useExamsByMasterExam";

const ExamCoursePlan = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const masterExamId = Number(location.state?.md_exam_id || location.state?.selectedMasterExam?.id || 0);
  const { data: masterExam = {}, isLoading, isError, error } = useExamsByMasterExam(masterExamId);
  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load exam courses."
    : "";

  return (
    <>
    <style>{`
    .rapid-fire-card {
        padding: 20px 0px;
    }

   `}</style>
      <HomeDashboardLayout showHeader={false} variant="exam-course-wallet-layout">
        <div className="qbl-page qbankList-page page-padding exam-courses-page">
          <div className="start-quiz qbl-main instruction-main">
            <div className="hideProfile-page">
              <div className="categories-page-header mb-0">
                <div>
                  <button type="button" className="categories-back-button" onClick={() => navigate(-1)}>
                    <i className="bi bi-chevron-left" />
                  </button>
                </div>
                <div><div className="d-flex d-sm-none categories-page-title" /></div>
                <div><HeaderProfileSection /></div>
              </div>
            </div>
            <ExamCourseHeader masterExam={masterExam} isLoading={isLoading} />
            <ExamCoursesCard exams={masterExam?.exam_list} masterExam={masterExam} isLoading={isLoading} error={loadError} />
          </div>
        </div>
        <MyWalletSidebar withTopOffset={false} />
      </HomeDashboardLayout>
    </>
  );
};

export default ExamCoursePlan;
